export default __webpack_public_path__ + "static/media/avatar.06b4049d.png";